import { FileText } from "lucide-react";
import { Handle, Position, type Node, type NodeProps } from "@xyflow/react";
import type { MeetingRouteNodeData } from "./types";

export function MeetingRouteNode({ data }: NodeProps<Node<MeetingRouteNodeData>>) {
  const { label, href, path, isEntry } = data;

  return (
    <div className="bg-white rounded-xl border-2 border-indigo-300 shadow-md w-[280px] relative pb-10">
      {!isEntry && (
        <Handle
          type="target"
          position={Position.Left}
          className="!bg-indigo-400 !w-3 !h-3 !border-2 !border-white"
          style={{ top: "22px", left: 0 }}
        />
      )}
      <div className="px-4 py-3 bg-indigo-50 rounded-t-xl border-b border-indigo-200">
        <div className="flex min-w-0 items-center gap-2">
          <FileText className="h-4 w-4 shrink-0 text-indigo-500" />
          <span className="font-semibold text-sm text-indigo-700">{label}</span>
        </div>
        {href && path ? (
          <button
            type="button"
            className="nodrag nopan pointer-events-auto cursor-pointer relative z-10 mt-1.5 block max-w-full truncate text-left text-xs text-indigo-600 hover:text-indigo-800 hover:underline"
            title={href}
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              window.open(href, "_blank", "noopener,noreferrer");
            }}
          >
            {path}
          </button>
        ) : null}
      </div>
      <div className="absolute bottom-2 right-0 flex items-center">
        {isEntry ? (
          <Handle
            type="source"
            position={Position.Bottom}
            id="checkout-success"
            className="!bg-indigo-400 !w-3 !h-3 !border-2 !border-white"
          />
        ) : null}
        <Handle
          type="source"
          position={Position.Right}
          id="flow"
          className="!bg-indigo-400 !w-3 !h-3 !border-2 !border-white"
        />
      </div>
    </div>
  );
}
